<template>
  <div
    class="row match-height"
    v-bind:class="{ fullscreen_expand: isFullscreen }"
  >
    <div class="col-xl-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Segurança</h4>
          <a class="heading-elements-toggle"
            ><i
              class="fa fa-ellipsis-v font-medium-3"
              @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
            ></i
          ></a>
          <div
            class="heading-elements"
            v-bind:class="{
              visible: getSubMenuShowHideFw(),
              '': !getSubMenuShowHideFw(),
            }"
          >
            <ul class="list-inline mb-0">
              <li>
                <a @click="onFilterReset()" v-b-tooltip title="Atualizar"
                  ><i class="ft-rotate-cw"></i
                ></a>
              </li>
              <li>
                <a
                  @click="expandFullscreen()"
                  v-b-tooltip
                  title="Expande a tela"
                  v-if="!isFullscreen"
                  ><i class="ft-maximize"></i
                ></a>
              </li>
              <li>
                <a
                  @click="expandFullscreen()"
                  v-b-tooltip
                  title="Minimiza a tela"
                  v-if="isFullscreen"
                  ><i class="ft-minimize"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="card-content">
          <div class="table-responsive col-md-12">
            <div class="row">
              <div class="col-md-12">
                <h4>Senha</h4>
                Há 3 níveis de senha que podem ser escolhidos:<br />
                <b>Simples</b> -> Mínimo de 6 caracteres com números e letras<br />
                <b>Normal</b> -> Mínimo de 6 caracteres com números, letras e no
                mínimo um caractere maiúsculo e um minúsculo<br />
                <b>Complexo</b> -> Mínimo de 8 caracteres com números, letras,
                caracteres especiais e no mínimo um caractere maiúsculo e um
                minúsculo<br />
                <multiselect
                  v-model="tpRegraSenhaSelected"
                  :options="this.$parent.optionsTpRegraSenha"
                  track-by="value"
                  label="label"
                  :hide-selected="true"
                  placeholder="Selecione"
                  id="tp_regra_senha"
                  tag-placeholder="Selecionar"
                  select-label="Selecionar"
                  selected-label="Selecionado"
                  deselect-label="Remover"
                ></multiselect>
                <b-form-feedback
                  class="text-danger"
                  v-text="form.errors.get('tp_regra_senha')"
                  v-if="form.errors.has('tp_regra_senha')"
                ></b-form-feedback>
              </div>
            </div>
              <b-row>

                <b-col>
                  <label
                    >Quantidade de dias para a senha expirar e exigir nova troca:
                  </label>
                  <b-form-input
                    type="text"
                    placeholder="Quantidade"
                    v-model="form.qtde_dias_troca_senha"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('qtde_dias_troca_senha')"
                    v-if="form.errors.has('qtde_dias_troca_senha')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label
                    >Quantidade de vezes que a senha antiga não pode ser
                    re-utilizada:</label
                  >
                  <b-form-input
                    type="text"
                    placeholder="Quantidade"
                    v-model="form.senha_qtde_historico"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('senha_qtde_historico')"
                    v-if="form.errors.has('senha_qtde_historico')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label
                    >Quantidade de vezes que o usuário pode errar até ter a senha
                    bloqueada:
                  </label>
                  <b-form-input
                    type="text"
                    placeholder="Quantidade"
                    v-model="form.qtde_erro_senha"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('qtde_erro_senha')"
                    v-if="form.errors.has('qtde_erro_senha')"
                  ></b-form-feedback>
                </b-col>
              </b-row>
              <b-row>
              <b-col>
                <label>Senhas proibidas:</label>
                <multiselect
                  v-model="dicionarioSenhaSelected"
                  :options="this.$parent.optionsLivStatusDicionario"
                  track-by="value"
                  label="label"
                  :hide-selected="true"
                  placeholder="Selecione"
                  tag-placeholder="Selecionar"
                  select-label="Selecionar"
                  selected-label="Selecionado"
                  deselect-label="Remover"
                ></multiselect>
                <b-form-feedback
                  class="text-danger"
                  v-text="form.errors.get('dicionario_senha.value')"
                  v-if="form.errors.has('dicionario_senha.value')"
                ></b-form-feedback>
              </b-col>
              <b-col>
                <label>Autenticação de dois fatores:</label>
                <multiselect
                  v-model="doisFatoresSelected"
                  :options="this.$parent.optionsLivStatusDoisFatores"
                  track-by="value"
                  label="label"
                  :hide-selected="true"
                  placeholder="Selecione"
                  tag-placeholder="Selecionar"
                  select-label="Selecionar"
                  selected-label="Selecionado"
                  deselect-label="Remover"
                ></multiselect>
                <b-form-feedback
                  class="text-danger"
                  v-text="form.errors.get('dois_fatores.value')"
                  v-if="form.errors.has('dois_fatores.value')"
                ></b-form-feedback>
              </b-col>

              <b-col>
                <label>Autenticação de dois fatores primário:</label>
                <multiselect
                  v-model="doisFatoresPrimarioSelected"
                  :options="this.$parent.optionsLivTpDoisFatoresPrimario"
                  track-by="value"
                  label="label"
                  :hide-selected="true"
                  placeholder="Selecione"
                  tag-placeholder="Selecionar"
                  select-label="Selecionar"
                  selected-label="Selecionado"
                  deselect-label="Remover"
                ></multiselect>
                <b-form-feedback
                  class="text-danger"
                  v-text="form.errors.get('dois_fatores_primario.value')"
                  v-if="form.errors.has('dois_fatores_primario.value')"
                ></b-form-feedback>
              </b-col>
              <b-col>
                <label>Autenticação de dois fatores alternativo:</label>
                <multiselect
                  v-model="doisFatoresAlternativoSelected"
                  :options="this.$parent.optionsLivTpDoisFatoresAlternativo"
                  track-by="value"
                  label="label"
                  :hide-selected="true"
                  placeholder="Selecione"
                  tag-placeholder="Selecionar"
                  select-label="Selecionar"
                  selected-label="Selecionado"
                  deselect-label="Remover"
                ></multiselect>
                <b-form-feedback
                  class="text-danger"
                  v-text="form.errors.get('dois_fatores_alternativo.value')"
                  v-if="form.errors.has('dois_fatores_alternativo.value')"
                ></b-form-feedback>
              </b-col>
              </b-row>
              
              <div class="col-md-12 mt-1">
                <div
                  class="float-right"
                  v-if="getPermission('conta.update.seguranca')"
                >
                  <b-btn
                    @click="onUpdateSeguranca()"
                    variant="secondary"
                    :disabled="isDisabled"
                  >
                    Salvar mudanças
                  </b-btn>
                </div>
              </div>

              <div class="col-md-12 pt-1" style="margin-top:40px;">
                <h4 class="card-title">Cadastrar nova senha proibida</h4>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-input
                      type="text"
                      placeholder="Código"
                      v-model="formdicionario.cd"
                    >
                    </b-form-input>
                  </div>
                  <div class="col-md-4">
                    <b-form-input
                      type="text"
                      placeholder="Senha"
                      v-model="formdicionario.senha"
                    >
                    </b-form-input>
                  </div>
                  <div class="col-md-2">
                    <multiselect
                      v-model="formdicionario.status"
                      :options="this.$parent.optionsLivStatusDicionario"
                      track-by="value"
                      label="label"
                      :hide-selected="true"
                      placeholder="Selecione"
                      tag-placeholder="Selecionar"
                      select-label="Selecionar"
                      selected-label="Selecionado"
                      deselect-label="Remover"
                    ></multiselect>
                  </div>
                  <div
                    class="col-md-2"
                    v-if="getPermission('conta.update.seguranca')"
                  >
                    <b-btn
                      @click="onStoreDicionario()"
                      variant="secondary"
                      :disabled="isDisabled"
                    >
                      Cadastrar
                    </b-btn>
                  </div>
                </div>

                <div class="pt-1">
                  <h4 class="card-title">Senhas proibidas</h4>
                  <div class="col-md-12">
                    <table class="table" id="mais">
                      <thead>
                        <tr>
                          <th style="width: 40%">Código</th>
                          <th style="width: 40%">Senha</th>
                          <th style="width: 10%">Status</th>
                          <th style="width: 10%">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="bg-gray-light"
                          style="display: table-row"
                          v-for="item in this.formdicionariov"
                        >
                          <td>
                            {{ item.cd }}
                          </td>
                          <td>
                            {{ item.senha }}
                          </td>
                          <td>
                            <span
                              class="badge badge-success"
                              v-if="item.valor == 1"
                              >{{ item.status }}</span
                            >
                            <span
                              class="badge badge-danger"
                              v-if="item.valor == 2"
                              >{{ item.status }}</span
                            >
                          </td>
                          <td>
                            <a
                              @click="onDestroy(item, false)"
                              v-b-tooltip
                              title="Excluir"
                              ><i
                                class="fa fa-trash"
                                v-if="getPermission('conta.update.seguranca')"
                              ></i
                            ></a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueClipboard from "vue-clipboard2";
import ToggleButton from "vue-js-toggle-button";
import moment from "moment";

Vue.use(VueClipboard);
Vue.use(ToggleButton);

export default {
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      teste: "",
      isFullscreen: false,
      loading: false,
      disabled: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalPermission: false,
      optionsLivStatusDicionario: [],
      optionsLivStatusDoisFatores: [],
      optionsLivTpDoisFatoresAlternativo: [],
      optionsLivTpDoisFatoresPrimario: [],
      tpRegraSenhaSelected: [],
      dicionarioSenhaSelected: [],
      doisFatoresSelected: [],
      doisFatoresPrimarioSelected: [],
      doisFatoresAlternativoSelected: [],
      isLoadingPeju: false,
      isLoadingPefi: false,
      formdicionariov: [
        {
          cd: "",
          senha: "",
          status: "",
          valor: "",
          dicsenh_id: ""
        }
      ],
      form: new Form({
        tp_regra_senha: "",
        qtde_dias_troca_senha: "",
        senha_qtde_historico: "",
        qtde_erro_senha: "",
        dicionario_senha: "",
        dois_fatores: "",
        dois_fatores_primario: "",
        dois_fatores_alternativo: ""
      }),
      formdicionario: new Form({
        cd: "",
        senha: "",
        status: []
      }),
      helpForm: new Form({
        statusRecord: [],
        senhadicionario: [],
        params: [],
        search: ""
      }),
      moreParams: {}
    };
  },
  watch: {
    tpRegraSenhaSelected(obj) {
      this.form.tp_regra_senha = obj.value;
    },
    dicionarioSenhaSelected(obj) {
      this.form.dicionario_senha = obj.value;
    },
    doisFatoresSelected(obj) {
      this.form.dois_fatores = obj.value;
    },
    doisFatoresPrimarioSelected(obj) {
      this.form.dois_fatores_primario = obj.value;
    },
    doisFatoresAlternativoSelected(obj) {
      this.form.dois_fatores_alternativo = obj.value;
    }
  },
  mounted() {
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", e => this.onFilterReset());
    this.$events.$on("reloadResponse", response =>
      this.onReloadResponse(response)
    );
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function(data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.id);
      }
    },
    onUpdateSeguranca() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/conta/update/seguranca")
        .then(response => {
          new ReturnApi(response, this);
          this.segurancaData();
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },
    segurancaData() {
      this.loadingData = true;
      this.formdicionariov = [];
      this.form
        .get("/api/conta/seguranca")
        .then(response => {
          new ReturnApi(response, this);
          this.form.qtde_erro_senha =
            response.data.BConfigBlogistic.qtdeErroSenha;
          this.form.qtde_dias_troca_senha =
            response.data.BConfigBlogistic.qtdeDiasTrocaSenha;
          this.form.senha_qtde_historico =
            response.data.BConfigBlogistic.senhaQtdeHistorico;

          this.tpRegraSenhaSelected = {
            label: response.data.BConfigBlogistic.tpRegraSenha.descr,
            value: response.data.BConfigBlogistic.tpRegraSenha.valor
          };
          this.dicionarioSenhaSelected = {
            label: response.data.BConfigBlogistic.statusDicionario.descr,
            value: response.data.BConfigBlogistic.statusDicionario.valor
          };
          this.doisFatoresSelected = {
            label: response.data.BConfigBlogistic.statusDoisFatores.descr,
            value: response.data.BConfigBlogistic.statusDoisFatores.valor
          };

          this.doisFatoresPrimarioSelected = {
            label: response.data.BConfigBlogistic.tpDoisFatoresPrimario.descr,
            value: response.data.BConfigBlogistic.tpDoisFatoresPrimario.valor
          };

          this.doisFatoresAlternativoSelected = {
            label: response.data.BConfigBlogistic.tpDoisFatoresAlternativo.descr,
            value: response.data.BConfigBlogistic.tpDoisFatoresAlternativo.valor
          };

          response.data.DicionarioSenha.forEach(obj => {
            this.formdicionariov.push({
              cd: obj.cd,
              senha: obj.senha,
              status: obj.status.descr,
              dicsenh_id: obj.dicsenh_id
            })
          });

        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
      this.loadingData = false;
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onDestroy(data, tipo) {
      // Tipo = true = Checkbox
      // Destroy apenas na linha
      if (!tipo) {
        this.helpForm.senhadicionario = [];
        this.helpForm.senhadicionario.push({
          senha: data.senha,
          dicsenh_id: data.dicsenh_id
        });
      }

      this.helpForm
        .post("/api/conta/destroy/dicionario")
        .then(response => {
          this.segurancaData();
        })
        .catch(errors => {
          this.segurancaData();
        });
    },
    onStoreDicionario() {
      this.loading = true;
      this.isDisabled = true;
      this.formdicionario
        .post("/api/conta/store/dicionario")
        .then(response => {
          new ReturnApi(response, this);
          this.segurancaData();
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    onReloadResponse(response) {
      new ReturnApi(response, this);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.state.logged.user;
      }
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
